import { TApplicationState } from '../../types/redux';
import { getHouses } from './getHouses';

export function getIsEscrowCurrentHouse(state: TApplicationState) {
  const houses = getHouses(state);
  const selectedHouseId = state.offers.selectedHouseId;

  if (selectedHouseId) {
    const selectedHouse = houses.find(house => house.houseId === selectedHouseId);

    return selectedHouse?.isEscrow || false;
  }

  return state.newbuilding.isEscrow;
}
